import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { postLogDetails } from "../../../Services/APIs/appDetails";
import teethSides from "../../../Utils/teethSideNames";
import { steps } from "./steps";
import close from "../../../assets/Icons/close-white.png"
import signalAILogo from "../../../assets/illustrations/signal-AI.png"


const DemoScreens = (props) => {
    const [cameraSide, setCameraSide] = useState(localStorage.getItem("cameraSide") || "front");
    const [isUpperJawDemonstration, setUpperJawDemonstration] = useState(false)
    const { activeImageSide, setDemo, setCamera, quickScan } = props
    const navigate = useNavigate()

    useEffect(() => {
        postLogDetails({
            uid: JSON.parse(localStorage.getItem("usertpi") || "{}").usertpi,
            app: JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket,
            payLoad: `viewed ${teethSides[activeImageSide]} teeth demo screen`
        })

    }, [])


    const gotIt = () => {
        setDemo(false)
        setCamera(true)
    }

    return (
        <>

            {/* isUpperJawDemonstration ? <UpperJawDemonstartion gotIt={gotIt} back={setUpperJawDemonstration} /> : */}
            <div className="h-full w-full">
                <div className="z-20 relative h-full w-full text-end text-white ">
                    {/* <button className="p-1" onClick={() => window.history.back()} > <img src={close} className="w-7 h-7 m-2" alt="close" /> </button> */}
                    <img src={signalAILogo} className=" w-2/5 mx-auto mt-4" alt="signalai" />
                    <h1 className=" text-center text-4xl font-medium -mt-1">{steps[activeImageSide].label}</h1>
                    <div className="w-full flex flex-col items-center absolute bottom-8 text-center">
                        {
                            activeImageSide === 4 ?
                                <div className="mb-10 mx-6">

                                    ဖုန်းကိုပြောင်းပြန်ထား၍ သွားအပေါ်ဘက်ကို ပုံရိုက်ပါ

                                </div>
                                :
                                <p className="mb-10 mx-10 text-left">
                                    ပုံတွင်ပြထားတဲ့အတိုင်းသင့်သွားကိုအကွက်အတွင်းထဲထားပြီး ဖုန်းစခရင်ကိုတစ်ချက်နှိပ်ပြီး ပုံရိုက်ပါ။
                                </p>
                        }
                        <button className="text-center w-44 h-12 bg-signal-ai-secondary text-white font-medium rounded-md" onClick={gotIt} >
                            <span> ပုံရိုက်မည် </span>  </button>
                    </div>
                </div>
                <div className="z-10 absolute top-0 w-full h-full">
                    <img src={steps[activeImageSide].image} alt={"front teeth"} className="w-full h-full" />
                </div>
            </div>
            {/* } */}
        </>

    )
}

export default DemoScreens